<template>
    <h1 v-if="!tag" class="sr-only">Education</h1>
    <div v-if="tag" class="pb-[30px] mb-[30px] at1024:pb-[60px] at1024:mb-[60px] border-b border-[#eaeaea] w-full">
        <h1 class="text-[24px] font-medium mb-4 at1024:text-[36px]">{{ $t('Articles in') }}: {{ tag.name }}</h1>
        <p class="flex flex-wrap items-baseline gap-2 text-[18px] text-[#63666a] at1024:text-[23px]">
            <span>
                <strong>{{ articles.total }}</strong>
                {{ articles.total === 1 ? "result" : "results" }}
            </span>
            <Link :href="route('web.education.index')" class="border-b border-current hover:text-black">{{ $t('Clear') }}</Link>
        </p>
    </div>

    <ArticleCard v-for="article in articles.data" :article="article" :key="article.id"/>

<!--    <div class="flex justify-end gap-2 items-baseline" v-if="articles.last_page > 1">-->
<!--        <Link :href="articles.prev_page_url" v-if="articles.prev_page_url" class="group">-->
<!--            <BaseSvg name="icon-chevron-left" class="p-1.5 rounded-full bg-gray-125 group-hover:bg-gray-175 group-active:bg-gray-150"/>-->
<!--            <span class="sr-only">{{ $t('Previous') }}</span>-->
<!--        </Link>-->
<!--        <Link :href="articles.next_page_url" class="group" v-if="articles.next_page_url">-->
<!--            <BaseSvg name="icon-chevron-right" class="p-1.5 rounded-full bg-gray-125 group-hover:bg-gray-175 group-active:bg-gray-150"/>-->
<!--            <span class="sr-only">{{ $t('Next') }}</span>-->
<!--        </Link>-->
<!--    </div>-->

    <NumberedPagination :data="articles" />

    <Meta
        :title="tag?.name ? tag.name + ' – Education' : 'Education: Door Hardware Insights & Guides'"
        :jsonLdMainEntity="jsonLdMainEntityBlogIndex(articles, categories)"
        :description="tag?.name ? 'Read ' + tag.name + ' articles on commercial door hardware trends, product insights, and industry expertise from SECLOCK professionals.' : 'Read articles on commercial door hardware trends, product insights, and industry expertise from SECLOCK professionals.'"
        :jsonLdBreadcrumbs="[
            { title: 'Home', url: 'https://www.seclock.com' },
            { title: 'Education', url: 'https://www.seclock.com/education' }
        ]"
    />
</template>

<script setup>
import { ArticleCard, Meta, BaseSvg } from "@/Components";
import { useJsonLd } from "@/Composables";
import NumberedPagination from "@/Themes/Marketing/Components/Modules/Search/NumberedPagination.vue";
const { jsonLdMainEntityBlogIndex } = useJsonLd();

const props = defineProps([
    "tag",
    "articles",
    "featured",
    "crumbs",
    "categories",
    "searchSettings"
]);
</script>
